import { connect } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';

import { profileGet } from 'store/modules/user/actions';
import { State as StoreState } from 'store/state';

import Component from './component';
import { Props } from './types';

const mapStateToProps = (state: StoreState, ownProps?: Props): object => {
    return {
        state: {
            authToken: state.user.authToken,
            refreshToken: state.user.refreshToken,
            profile: state.user.profile,
        },
    };
};

const mapDispatchToProps = (dispatch: Dispatch): object => {
    return {
        actions: {
            profileGet: bindActionCreators(profileGet, dispatch),
        },
    };
};

Component.defaultProps = {};
export default connect(mapStateToProps, mapDispatchToProps)(Component);
